import styled from 'styled-components'
import Twemoji from 'react-twemoji'

export const StyledTwemoji = styled(Twemoji)`
  display: flex;
  align-items: center;
  margin-right: 8px;

  img {
    height: 16px;
    width: 16px;
  }
`

export const OptionWrapper = styled.div`
  width: 100%;
  white-space: nowrap;
  display: flex;
  align-items: center;
`

export const StyledSingleValue = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  margin-left: 18px;
  transform: translateY(-50%);
`
